<template>
  <el-dialog @close="close" :visible.sync="dialogVisible" width="500px" :center="true">
    <img style="width: 430px;height: 430px;" :src="url" alt="">
    <el-button :loading="loading" style="display: block;margin: 20px auto 0;" type="primary" @click="download()">下载
    </el-button>
  </el-dialog>
</template>

<script>
import {downloadImg} from "@/helpers";

export default {
  name: "download-img",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: undefined
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
    }
  },
  methods: {
    close() {
      this.$emit('downed')
    },
    async download() {
      this.loading = true
      await downloadImg(this.name, this.url)
      this.loading = false
      this.close()
    }
  }
}
</script>

<style scoped>
</style>